/// <reference path="DOMAttached.js" />

class ControlSwitcher extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.initiallyShownControl = document.getElementById(options.initiallyShownControl);
		this.initiallyHiddenControl = document.getElementById(options.initiallyHiddenControl);
		this.clickableControl = document.getElementById(options.clickableControl);
		this.safeObserve(this.clickableControl, 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		ev.preventDefault();
		this.initiallyShownControl.style.display = 'none';
		this.initiallyHiddenControl.style.display = 'block';
	}
}
